<template>
    <div
        id="vrm-modal-notification"
        class="vrm-modal vrm-modal--alert mfp-with-anim vrm-modal-notification"
    >
        <div class="vrm-modal__content">
            <div class="vrm-modal__title">
                {{ $t('paygo.confirmation.title', { i18nFallback: 'vh' }) }}
            </div>
            <p>
                {{
                    $t('paygo.confirmation.text', {
                        i18nFallback:
                            'Do you wish to generate a token to disable PAYGo mode? You cannot undo this action.',
                    })
                }}
            </p>
            <div class="vrm-modal__main-button">
                <button class="sg-element sg-btn sg-red" @click="acceptModal">
                    {{ $t('paygo.confirmation.yes', { i18nFallback: 'Yes, disable PAYGo mode' }) }}
                </button>
                <button class="sg-element sg-btn sg-site" @click="closeModal">
                    {{ $t('paygo.confirmation.no', { i18nFallback: 'No, cancel' }) }}
                </button>
            </div>
        </div>
        <modal-close-handle />
    </div>
</template>

<script>
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
        ModalCloseHandle,
    },
})
@AngularDirective('vrm-disable-paygo-modal')
@AngularLocaleBundle('core')
@AngularLocaleBundle('common')
@AngularLocaleBundle('paygo')
export default class VrmDisablePaygoModal extends Vue {
    @Prop()
    callback;

    closeModal() {
        //Do not change to this.$emit('close'), since this will break queued notifications
        $.magnificPopup.close();
    }

    acceptModal() {
        this.callback();
        this.closeModal();
    }
}
</script>
